export default "__VITE_ASSET__8414e060__"